export default __webpack_public_path__ + "email_icon.9ea92c.svg";